import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
export function SocialProof() {
  return <section className="w-full bg-warm-dark py-20 md:py-28 relative overflow-hidden" data-id="element-144">
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-145">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="text-center mb-14" data-id="element-146">
          <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold text-cream leading-snug mb-6" data-id="element-147">
            Personas reales,{' '}
            <span className="text-amber italic" data-id="element-148">resultados reales</span>
          </h2>
          <p className="font-body text-cream-muted/75 text-base sm:text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-149">
            Este libro ha sido creado tomando en cuenta estrategias probadas y
            accesibles. Muchas personas ya han transformado su vida aplicando
            estos métodos, recuperando su autoestima incluso en tiempos
            difíciles.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-150">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-warm-dark-alt border border-warm-border rounded-2xl p-6 sm:p-8" data-id="element-151">
            <QuoteIcon className="w-8 h-8 text-amber/30 mb-4" aria-hidden="true" data-id="element-152" />
            <p className="font-body text-cream-muted/80 text-sm sm:text-base leading-relaxed mb-6 italic" data-id="element-153">
              "Estaba pasando por un momento muy difícil y este libro me dio las
              herramientas que necesitaba. Los ejercicios de respiración
              cambiaron mi día a día."
            </p>
            <div data-id="element-154">
              <p className="font-body font-semibold text-cream text-sm" data-id="element-155">
                María L.
              </p>
              <p className="font-body text-warm-gray text-xs" data-id="element-156">
                Buenos Aires, Argentina
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: 0.25
        }} className="bg-warm-dark-alt border border-warm-border rounded-2xl p-6 sm:p-8" data-id="element-157">
            <QuoteIcon className="w-8 h-8 text-amber/30 mb-4" aria-hidden="true" data-id="element-158" />
            <p className="font-body text-cream-muted/80 text-sm sm:text-base leading-relaxed mb-6 italic" data-id="element-159">
              "Nunca pensé que un eBook pudiera tener tanto impacto. Los cinco
              pilares son fáciles de seguir y realmente funcionan. Recuperé mi
              confianza en pocas semanas."
            </p>
            <div data-id="element-160">
              <p className="font-body font-semibold text-cream text-sm" data-id="element-161">
                Carlos R.
              </p>
              <p className="font-body text-warm-gray text-xs" data-id="element-162">
                Córdoba, Argentina
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="bg-warm-dark-alt border border-warm-border rounded-2xl p-6 sm:p-8" data-id="element-163">
            <QuoteIcon className="w-8 h-8 text-amber/30 mb-4" aria-hidden="true" data-id="element-164" />
            <p className="font-body text-cream-muted/80 text-sm sm:text-base leading-relaxed mb-6 italic" data-id="element-165">
              "La visualización de metas me abrió los ojos. Ahora veo
              oportunidades donde antes solo veía problemas. Lo recomiendo de
              corazón."
            </p>
            <div data-id="element-166">
              <p className="font-body font-semibold text-cream text-sm" data-id="element-167">
                Ana G.
              </p>
              <p className="font-body text-warm-gray text-xs" data-id="element-168">
                Rosario, Argentina
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}